import React, { useState, useEffect, useRef } from "react"
import algoliasearch from "algoliasearch/lite"
import { graphql } from "gatsby"
import {
  connectStats,
  RefinementList,
  InstantSearch,
  Configure,
  connectHits,
  connectStateResults,
  connectGeoSearch,
  SearchBox,
} from "react-instantsearch-dom"
import {
  isTablet,
  isIPad13,
  isIOS13,
  isMobile,
  isMobileOnly,
  isDesktop,
  browserName,
} from "react-device-detect"
// import Loader from "../components/loader";
import { Col, Container, Row, Form } from "react-bootstrap"
import $ from "jquery"
// Include only the reset
//import 'instantsearch.css/themes/reset.css';
// or include the full Satellite theme
//import 'instantsearch.css/themes/satellite.css';

import Header from "../components/Header/Header"
import markerImageSrc from "../images/map-marker.svg"
import NoImage from "../images/pittis-no-image.png"
import Footer from "../components/Footer/Footer"
import FilterBlock from "../components/SearchResult/FilterBlock/FilterBlock"
import SearchList from "../components/SearchResult/SearchList/SearchList"
import "../components/SearchResult/SearchResult.scss"
import LoadExternalScript from "../components/utils/load-external-script"
import classNames from "classnames"
import { useLocation } from "@reach/router"
import {
  FIND_A_PROPERTY_PAGE_URL,
  FIND_A_PROPERTY_RENT_PAGE_URL,
} from "../components/common/site/constants"

import Loadable from "@loadable/component"
import MapResultsDesktop from "../components/map/search-results-os-map"
import "../components/map/osmap.scss"
import * as L from "leaflet"
import { GestureHandling } from "leaflet-gesture-handling";
import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
//import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import "leaflet.markercluster"

// const MapResultsMobile = Loadable(() => import("../components/map/search-results-locrating-map-mobile"));

const client = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_API_KEY
)
const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME

const CustomInfiniteHits = connectHits(SearchList)

// No Results
const NoStats = ({ processingTimeMS, nbHits, val, type }) => {
  return (
    <>
      {nbHits === 0 && (
        <Container>
          <Row>
            <Col lg={12} className="text-center no-properties-text mb-5">
              <h4>
                Unfortunately, we do not currently have any properties that
                match your search criteria.
              </h4>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "blackwater-newport-isle-of-wight")
                  localStorage.setItem("searchValueFull", "blackwater-newport-isle-of-wight")
                  localStorage.setItem("searchValueFullName", "blackwater-newport-isle-of-wight")
                }}
                href={
                  type == "sales"
                    ? FIND_A_PROPERTY_PAGE_URL.alias
                    : FIND_A_PROPERTY_RENT_PAGE_URL.alias
                }
                className="reset-link"
              >
                Reset the search
              </a>
            </Col>
          </Row>
        </Container>
      )}
    </>
  )
}

const CustomNoStats = connectStats(NoStats)
// No Results

const HitList = ({ hits }) => {
  const { pathname } = useLocation();
  
  // useRef to store the previous hits data
  const prevHitsRef = useRef();

  useEffect(() => {
    // Check if hits data has changed
    if (JSON.stringify(hits) !== JSON.stringify(prevHitsRef.current)) {
      // Only update localStorage if the hits data has changed
      localStorage.setItem('searchResultPath', pathname);
      localStorage.setItem('algoliaResult', JSON.stringify(hits));

      // Update the previous hits reference
      prevHitsRef.current = hits;
    }
  }, [hits, pathname]);  

  return null;
};
const CustomAllHits = connectHits(HitList)

//map section
class GeoSearch extends React.Component {
  isUserInteraction = true
  markers = []
  autopan = false;

  componentDidMount() {
    const { refine } = this.props
    if (typeof window !== "undefined") {

      L.Control.include({
        _refocusOnMap: L.Util.falseFn // Do nothing. when click zoom icon avoid map element focus
      });
      if (isTablet || isMobile) {
        this.instance = new L.map(this.el, { gestureHandling: true, zoom: 21 })
      } else {
        this.instance = new L.map(this.el, { gestureHandling: false, zoom: 21 })
      }

      new L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png", {
        attribution:
          '&copy; <a class="mapcopyright" href="http://osm.org/copyright" target="_blank">OpenStreetMap</a> contributors',
      }).addTo(this.instance)

      window.addEventListener('resize', this.instance.invalidateSize())

      this.instance.on("autopanstart", (e) => {
        this.autopan = true
      })

      this.instance.on("moveend", () => {
        if (this.autopan == false) {
          if (this.isUserInteraction) {
            const ne = this.instance.getBounds().getNorthEast()
            const sw = this.instance.getBounds().getSouthWest()
            if (ne.lat != sw.lat && ne.lng != sw.lng && ne.lng < 180) {
              refine({
                northEast: { lat: ne.lat, lng: ne.lng },
                southWest: { lat: sw.lat, lng: sw.lng },
              })
              // this.props.mapdraggedbyuser(true);
              //localStorage.setItem('searchValue', '');
            }
          }
        }
        this.autopan = false
      })
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener('resize', this.instance.invalidateSize())
    }
  }
  getButtonRestElem = () => {
    return this.buttonrest;
  }
  componentDidUpdate(prevProps) {
    const { refine } = this.props
    if (prevProps.enablecluster !== this.props.enablecluster) {
      window.removeEventListener('resize', this.instance.invalidateSize())
    }
    if (prevProps.enablecluster == "") {
      window.removeEventListener('resize', this.instance.invalidateSize())
    }
    const { hits, currentRefinement, position } = this.props
    if(hits.length>0){
      localStorage.setItem('algoliaResult', JSON.stringify(hits))
   }
    if (typeof window !== "undefined") {
      window.removeEventListener('resize', this.instance.invalidateSize())
    }
    this.markers.forEach(marker => marker.remove())
    if (typeof window !== "undefined") {
      //const markersCluster = new L.MarkerClusterGroup();
      if (this.props?.enablecluster == "true") {
        var markersCluster = new L.markerClusterGroup({
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: true,
          zoomToBoundsOnClick: true,
        })
      }
      var myIcon = new L.icon({
        iconUrl: markerImageSrc,
        shadowUrl: "",

        iconSize: [22, 23], // size of the icon
        shadowSize: [22, 23], // size of the shadow
        // iconAnchor: [22, 94], // point of the icon which will correspond to marker's location
        // shadowAnchor: [4, 62], // the same for the shadow
        popupAnchor: [-3, -6], // point from which the popup should open relative to the iconAnchor
      })
      //var bounds = new L.latLngBounds() // Instantiate LatLngBounds object
      if (this.props?.enablecluster == "false") {
        //this.instance.invalidateSize();
        this.markers = hits.map((hit) => {
          //bounds.extend([hit._geoloc.lat, hit._geoloc.lng])// for fitbounds
          return new L.marker([hit._geoloc.lat, hit._geoloc.lng], { icon: myIcon }).addTo(this.instance).on(
            "click",
            function () {
              var target = $("#" + hit.objectID)
              if (target.length) {
                $("html,body").animate(
                  { scrollTop: target.offset().top - 100 },
                  10
                )
                $(target).addClass("active").siblings().removeClass("active")
              }
            }
          )
        })
        //if(bounds?._northEast?.lat > 0){
        //this.instance.fitBounds(bounds)
        //}
      }
      if (this.props?.enablecluster == "true") {
        //this.instance.invalidateSize();
        this.markers = hits.map((hit) => {
          //bounds.extend([hit._geoloc.lat, hit._geoloc.lng])// for fitbounds
          let _price = hit.price?.toLocaleString();
          let _html = hit.display_address;
          let _title = hit.title
          let _bedroom = hit.bedroom
          let _bathroom = hit.bathroom
          let _reception = hit.reception
          let _bedroom_show = 'none'
          let _bathroom_show = 'none'
          let _reception_show = 'none'
          if (hit.bedroom) {
            _bedroom_show = 'block'
          }
          if (hit.bathroom) {
            _bathroom_show = 'block'
          }
          if (hit.reception) {
            _reception_show = 'block'
          }
          var image_url = ''
          if (hit?.images1 && hit?.images1.images_src?.length > 0) {
            // image_url = hit?.images3?.images[0]?.['165x107'] || hit?.images3?.images_src[0];
            image_url = hit?.images1.images_src[0];

          } else {
            image_url = NoImage
          }

          var url = ''
          if (hit.search_type === "sales") {
            url = '/property-for-sale/' + hit.slug + '-' + hit.crm_id
          }
          else if (hit.search_type === "lettings") {
            url = '/property-to-rent/' + hit.slug + '-' + hit.crm_id
          }
          return markersCluster.addLayer(new L.marker([hit._geoloc.lat, hit._geoloc.lng], { icon: myIcon }).bindPopup('<div><a href=' + process.env.GATSBY_SITE_URL + url + '><img src=' + image_url + ' style="width: 100%;height: 200px;object-fit: cover;" /></a><div style="padding: 20px;padding-bottom:24px;width:100%;"><p style="font-size:16px;color: #034051;padding-top:0px;font-family:GothamBook;margin-top: 5px;margin-bottom: 10px;">' + _html + '</p><p style="font-family:GothamBook;font-size: 16px;line-height:26px;color: #005670;margin-top: 0;margin-bottom: 15px;font-weight: 600;">£' + _price + '</p><div style="display:flex;margin-bottom:15px;"><div style="display:' + _bedroom_show + ';color: #4D676F;align-items: center;font-size: 14px;font-family: GothamBook;margin-right: 20px !important;"><svg style="margin-right:10px;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 15.75V7.5H19.5C20.2956 7.5 21.0587 7.81607 21.6213 8.37868C22.1839 8.94129 22.5 9.70435 22.5 10.5V15.75" stroke="#95C7D6" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.5 19.5V4.5" stroke="#95C7D6" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.5 15.75H22.5V19.5" stroke="#95C7D6" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.75 7.5H1.5" stroke="#95C7D6" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' + _bedroom + '</div><div style="display:' + _bathroom_show + ';color: #4D676F;align-items: center;font-size: 14px;font-family: GothamBook;margin-right: 20px !important;"><svg style="margin-right:10px;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5312 12.9842H4.78125V5.60141C4.78049 5.32338 4.83488 5.04796 4.94128 4.79109C5.04768 4.53422 5.20398 4.30101 5.40112 4.10495L5.41753 4.08855C5.72648 3.78005 6.12315 3.57445 6.55333 3.49985C6.98352 3.42525 7.42625 3.48528 7.82104 3.67175C7.4482 4.29165 7.29322 5.01839 7.38075 5.73646C7.46828 6.45454 7.79329 7.12277 8.30412 7.63496L8.75328 8.08413L7.92653 8.91092L8.85455 9.83894L9.6813 9.01219L14.2623 4.43127L15.0891 3.60452L14.161 2.67646L13.3342 3.50321L12.885 3.05405C12.3473 2.51779 11.6384 2.18721 10.8819 2.11993C10.1254 2.05266 9.36933 2.25295 8.74537 2.6859C8.0874 2.27037 7.30768 2.09099 6.53428 2.17721C5.76088 2.26343 5.0398 2.61014 4.48951 3.16036L4.4731 3.17677C4.15369 3.49443 3.90045 3.8723 3.72806 4.28849C3.55566 4.70468 3.46752 5.15093 3.46875 5.60141V12.9842H2.15625V14.2967H3.46875V15.5559C3.46872 15.6617 3.48579 15.7668 3.51928 15.8672L4.74023 19.5299C4.80539 19.726 4.93068 19.8965 5.0983 20.0174C5.26593 20.1382 5.46736 20.2031 5.674 20.203H6.2031L5.72461 21.8436H7.09178L7.57031 20.203H16.1057L16.5979 21.8436H17.9678L17.4756 20.203H18.3258C18.5325 20.2032 18.734 20.1382 18.9016 20.0174C19.0693 19.8966 19.1946 19.726 19.2598 19.5299L20.4806 15.8672C20.5141 15.7668 20.5312 15.6617 20.5312 15.5559V14.2967H21.8438V12.9842H20.5312ZM9.23227 3.98211C9.59386 3.62131 10.0838 3.41867 10.5946 3.41867C11.1054 3.41867 11.5954 3.62131 11.957 3.98211L12.4061 4.43127L9.68143 7.1559L9.23227 6.70682C8.87148 6.34522 8.66886 5.85527 8.66886 5.34447C8.66886 4.83366 8.87148 4.34371 9.23227 3.98211ZM19.2188 15.5026L18.0895 18.8905H5.91049L4.78125 15.5026V14.2967H19.2188V15.5026Z" fill="#95C7D6"/></svg>' + _bathroom + '</div><div style="display:' + _reception_show + ';color: #4D676F;align-items: center;font-size: 14px;font-family: GothamBook;margin-right: 20px !important;"><svg style="margin-right:10px;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0627 8.48231V6.75C20.0616 5.80549 19.6859 4.89998 19.0181 4.23211C18.3502 3.56424 17.4447 3.18857 16.5002 3.1875H7.50019C6.55568 3.18857 5.65017 3.56424 4.9823 4.23211C4.31443 4.89998 3.93876 5.80549 3.93769 6.75V8.48231C3.10094 8.61608 2.33926 9.04373 1.7894 9.68848C1.23954 10.3332 0.9375 11.1529 0.9375 12.0002C0.9375 12.8476 1.23954 13.6672 1.7894 14.312C2.33926 14.9567 3.10094 15.3844 3.93769 15.5182V18.75C3.93809 19.098 4.07649 19.4316 4.32255 19.6776C4.5686 19.9237 4.90221 20.0621 5.25019 20.0625H18.7502C19.0982 20.0621 19.4318 19.9237 19.6778 19.6776C19.9239 19.4316 20.0623 19.098 20.0627 18.75V15.5182C20.8994 15.3844 21.6611 14.9567 22.211 14.312C22.7608 13.6672 23.0629 12.8476 23.0629 12.0002C23.0629 11.1529 22.7608 10.3332 22.211 9.68848C21.6611 9.04373 20.8994 8.61608 20.0627 8.48231ZM7.50019 4.3125H16.5002C17.1464 4.31324 17.766 4.57029 18.2229 5.02725C18.6799 5.48421 18.9369 6.10376 18.9377 6.75V8.48231C18.1015 8.61714 17.3405 9.04506 16.7909 9.68953C16.2412 10.334 15.9388 11.153 15.9377 12V12.1875H8.06269V12C8.06156 11.153 7.75913 10.334 7.20951 9.68953C6.65988 9.04506 5.8989 8.61714 5.06269 8.48231V6.75C5.06343 6.10376 5.32048 5.48421 5.77744 5.02725C6.2344 4.57029 6.85395 4.31324 7.50019 4.3125ZM19.533 14.4373C19.5221 14.4367 19.5112 14.4364 19.5002 14.4364C19.351 14.4364 19.2079 14.4956 19.1024 14.6011C18.997 14.7066 18.9377 14.8497 18.9377 14.9989V18.75C18.9376 18.7997 18.9179 18.8474 18.8827 18.8825C18.8476 18.9177 18.7999 18.9375 18.7502 18.9375H5.25019C5.20048 18.9375 5.15281 18.9177 5.11766 18.8825C5.08251 18.8474 5.06274 18.7997 5.06269 18.75V14.9979C5.06244 14.8489 5.00307 14.7061 4.8976 14.6008C4.79214 14.4955 4.64921 14.4364 4.50019 14.4364C4.48919 14.4364 4.47825 14.4367 4.46738 14.4373C3.98673 14.4308 3.51872 14.2824 3.12221 14.0107C2.7257 13.7389 2.41839 13.356 2.23893 12.91C2.05947 12.4641 2.01587 11.9751 2.11361 11.5044C2.21135 11.0338 2.44606 10.6025 2.78824 10.2649C3.13042 9.9273 3.56479 9.6984 4.03671 9.607C4.50863 9.5156 4.99705 9.56578 5.44053 9.75122C5.88401 9.93666 6.26276 10.2491 6.52915 10.6492C6.79555 11.0493 6.93768 11.5193 6.93769 12V15.75C6.93769 15.8992 6.99695 16.0423 7.10244 16.1477C7.20793 16.2532 7.351 16.3125 7.50019 16.3125C7.64937 16.3125 7.79245 16.2532 7.89794 16.1477C8.00342 16.0423 8.06269 15.8992 8.06269 15.75V13.3125H15.9377V15.75C15.9377 15.8992 15.997 16.0423 16.1024 16.1477C16.2079 16.2532 16.351 16.3125 16.5002 16.3125C16.6494 16.3125 16.7924 16.2532 16.8979 16.1477C17.0034 16.0423 17.0627 15.8992 17.0627 15.75V12C17.0627 11.5193 17.2048 11.0493 17.4712 10.6492C17.7376 10.2491 18.1164 9.93666 18.5598 9.75122C19.0033 9.56578 19.4917 9.5156 19.9637 9.607C20.4356 9.6984 20.87 9.9273 21.2121 10.2649C21.5543 10.6025 21.789 11.0338 21.8868 11.5044C21.9845 11.9751 21.9409 12.4641 21.7614 12.91C21.582 13.356 21.2747 13.7389 20.8782 14.0107C20.4817 14.2824 20.0137 14.4308 19.533 14.4373Z" fill="#95C7D6"/></svg>' + _reception + '</div></div><a style="font-family:GothamBook;text-decoration:underline;color: #034051;margin-top:5px !important;" target="_parent" href=' + process.env.GATSBY_SITE_URL + url + ' >View Property Details</a></div></div>').openPopup())
        })
        //if(bounds?._northEast?.lat != ""){
        //this.instance.fitBounds(bounds)
        //}
      }
      //this.instance.addLayer(markersCluster)
      if (this.props?.enablecluster == "true") {
        markersCluster.addTo(this.instance);
      }

      this.isUserInteraction = false
      if (!currentRefinement && this.markers.length) {
        //if (this.props?.enablecluster == "false") {
          this.instance.flyToBounds(new L.featureGroup(this.markers).getBounds(), {
            animate: (this.props?.enablecluster == "true") ? true : false, duration: 1
          })
        //}
      } else if (!currentRefinement) {
        this.instance.setView(
          position || {
            lat: 51.1950576,
            lng: 0.1822206,
          },
          15,
          {
            animate: (this.props?.enablecluster == "true") ? true : false, duration: 1
          }
        )
      }
    }
    this.isUserInteraction = true
    // if (this.props?.enablecluster == "false") { //list view
    //   this.instance.on("mousedown mouseup touchend touchstart zoomanim", (e) => {
    //     console.log("visu i trigger")
    //     this.isUserInteraction = true
    //     this.props.mapdraggedbyuser(true);
    //   })
    // }
    if (this.props?.enablecluster == "true") {
      // this.isUserInteraction = true
      this.instance.on("resize", (e) => {
        if (prevProps.enablecluster == this.props.enablecluster) {
          refine();
          this.props.mapdraggedbyuser(false);
        }
      })
      this.instance.on("mousedown mouseup touchend touchstart zoomanim", (e) => {
        if (prevProps.enablecluster == this.props.enablecluster) {
          this.props.mapdraggedbyuser(true);
        }
      })
    } else {
      this.instance.on("mousedown mouseup touchend touchstart zoomanim", (e) => {
          this.props.mapdraggedbyuser(true);
      })
    }
  }

  render() {
    const { currentRefinement, refine } = this.props
    return (
      <div id="location-map" className={`${this.props?.enablecluster == "true" ? 'location-map' : ''}`}>
        <div ref={c => (this.el = c)} />
        {Boolean(currentRefinement) && (
          <button id="mymapclearBtn" ref={this.props.buttonrest} className="maprefinebutton" onClick={() => refine()}>Clear map refinement</button>
        )}
      </div>
    )
  }
}

const CustomGeoSearch = connectGeoSearch(GeoSearch)

// map section ends here

const SearchTemplate = props => {
  const [sold, setIncludeSold] = React.useState(false)
  const [scroll, setScroll] = useState(false)
  const [render, setRender] = useState(false)
  const [underOffer, setIncludeUnderOffer] = React.useState(false)
  const [scrollToTopBtn, setScrollToTop] = useState(false)
  // const [mapload, setMapLoad] = useState(false);
  const buttonrest = React.createRef();
  const [mapdragbyuser, setMapdragbyuser] = React.useState(false)
  // const setMapUrl = (map) => {
  //     if(map) {
  //         props.changeToMapUrl()
  //     } else {
  //         props.changeToListUrl()
  //     }
  // }

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 1)
      if (window.pageYOffset > 500) {
        setScrollToTop(true)
      } else {
        setScrollToTop(false)
      }
    })

    // iphone zoom issue when type a text in input field
    $("head").append(
      '<meta name="viewport" content="width=device-width, initial-scale=1.0, shrink-to-fit=no, maximum-scale=1.0, user-scalable=0">'
    )
    $("body").addClass("search-template")
    // iphone zoom issue when type a textin input field

    // setTimeout(() => {
    //     if(mapload) {
    //         setMapLoad(true)
    //     }
    // }, 3000);
    // if(!render){
    //   setRender(true)
    // }
   
  }, [])

  const includeSold = value => {
    setIncludeSold(value)
  }

  const mapdraggedbyuser = value => {
    setMapdragbyuser(value)
  }

  const includeUnderOffer = value => {
    setIncludeUnderOffer(value)
  }
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smoothly scrolling
    })
  }

  // const getRefinement = () => {
  //     if(props.searchType === "sales") {
  //         let sales = ["For Sale", "New Instruction"];
  //         if(sold && underOffer) {
  //             sales = ["For Sale", "New Instruction", "Sold", "Under Offer"];
  //         } else if(sold && !underOffer) {
  //             sales = ["For Sale", "New Instruction", "Sold"];
  //         } else if(!sold && underOffer) {
  //             sales = ["For Sale", "New Instruction", "Under Offer"];
  //         }
  //         return sales;
  //     } else {
  //         let rent = ["To Let", "New Instruction"];
  //         if(sold && underOffer) {
  //             rent = ["To Let", "New Instruction", "Let", "Under Offer"];
  //         } else if(sold && !underOffer) {
  //             rent = ["To Let", "New Instruction", "Let"];
  //         } else if(!sold && underOffer) {
  //             rent = ["To Let", "New Instruction", "Under Offer"];
  //         }
  //         return rent;
  //     }
  // }
  let realUser = true
  if( process.env.GATSBY_BlOCK_ALGOLIA_BOT_REQUEST == "true" ) { // only when ENV enabled
    if( typeof window !== 'undefined' ) {
      if ( (navigator.userAgent).indexOf("prerender") > 0 ){
        realUser = false
      }
    }
  }
  return (
    <div
      className={`${scroll
        ? "wrapper search-result-page scroll"
        : "wrapper search-result-page"
        }`}
    >
      <Header type="results" />
      {/* <LoadExternalScript
                src={locRatingScriptsJs}
                // async="true"
                //defer="true"
                //loadScript={renderMap}
            // appendScriptTo="head"
            /> */}
        {realUser && render &&
        <InstantSearch
        indexName={index_name}
        searchClient={client} 
        hits 
      > 
         <Configure filters={`publish:true AND search_type:${props.searchType} AND show_on_search:true`} aroundLatLng={props.aroundLatLng} aroundRadius={props.aroundRadius} getRankingInfo={props.getRankingInfo} {...props.algoliaConfig} hitsPerPage={200}    
         attributesToRetrieve = {[
          "crm_id",
          "slug"
        ]}
        facets= {["searchBuilding","price","bedroom","property_promotions"]} 
         /> 
         <div className="d-none"> 
         <SearchBox defaultRefinement={props.aroundRadius == 'all' ? 'kent' : ''}/>
         {/* {props.building &&
           <RefinementList attribute="searchBuilding" defaultRefinement={[props.building]}   />
         } */}
          <FilterBlock
          {...props}
          // setMapview={setMapUrl}
          searchDisable={true}
          buttonrest={buttonrest}
          includeSold={includeSold}
          mapdraggedbyuser={mapdraggedbyuser}
          includeUnderOffer={includeUnderOffer}
          mapView={props.mapView}
          searchType={props.searchType}
          query={props.query}
          index_name={index_name}
          search_area={props.search_area}
          h1={props.h1}
          desc={props.desc}
          off_plan={false}
          sales={props.searchType === "sales" ? true : false}
          changeRadius={props.changeRadius}
        />
       
         </div>
       
         <CustomAllHits  {...props} />
      </InstantSearch>
      }
      {realUser &&
      <InstantSearch
        indexName={index_name}
        searchClient={client}
        onSearchStateChange={state => {
          props.changeStateAndUrl(state)
        }}
        hits
      >
        <Configure page={0} filters={`publish:true AND search_type:${props.searchType} AND show_on_search:true`} aroundLatLng={props.aroundLatLng} aroundRadius={props.aroundRadius} getRankingInfo={props.getRankingInfo} {...props.algoliaConfig} />
        <FilterBlock
          {...props}
          searchDisable={false}
          // setMapview={setMapUrl}
          buttonrest={buttonrest}
          includeSold={includeSold}
          mapdraggedbyuser={mapdraggedbyuser}
          includeUnderOffer={includeUnderOffer}
          mapView={props.mapView}
          searchType={props.searchType}
          query={props.query}
          index_name={index_name}
          search_area={props.search_area}
          h1={props.h1}
          desc={props.desc}
          off_plan={false}
          sales={props.searchType === "sales" ? true : false}
          changeRadius={props.changeRadius}
        />
        {/* <div className="d-none"> */}
          {/* <RefinementList
                        attribute="department"
                        defaultRefinement={[props.department]}
                    /> */}
          {/* <RefinementList attribute="search_type" defaultRefinement={[props.searchType]} /> */}
          {/* <RefinementList
                            attribute="brand_id"
                            defaultRefinement={[process.env.GATSBY_STRAPI_BRAND_ID]}
                        /> */}
          {/* <RefinementList
                            attribute="status"
                            defaultRefinement={["SSTC (sales only)"]}
                        /> */}
          {/* <RefinementList attribute="publish" defaultRefinement={["true"]} /> */}
          {/* <RefinementList attribute="show_on_search" defaultRefinement={["true"]} /> */}
        {/* </div> */}
        <div
          className={`search-result-block mobile-view-results-page ${props.mapView ? " d-block" : ""
            }`}
        >
          {props.mapView ?
            <button className="exit-button" onClick={() => { props.changeToListUrl(); sessionStorage.setItem('MainView', 'List'); localStorage.removeItem('map-hits'); }}><i className="arrow-left"></i>Exit Map</button>
            : ''}
          <div className={`search-list-block ${props.mapView ? 'd-none' : ''}`}>
            <CustomInfiniteHits
              {...props}
              mapdragbyuser={mapdragbyuser}
              off_plan={false}
              index_name={index_name}
              search_area={props.search_area}
              sortByIndex={typeof window !== 'undefined' && localStorage.getItem('sortby-value') && typeof window !== 'undefined' && localStorage.getItem('sortby-value').includes("_price_asc") ? index_name + "_price_asc"
                :typeof window !== 'undefined' &&  localStorage.getItem('sortby-value') && localStorage.getItem('sortby-value').includes("_most_recent") ? index_name + "_most_recent"
                  : typeof window !== 'undefined' &&  localStorage.getItem('sortby-value') && localStorage.getItem('sortby-value').includes("_distance_asc") ? index_name + "_distance_asc"
                    : props.location.pathname.includes("most-recent")
                      ? index_name + "_most_recent"
                      : props.location.pathname.includes("distance-asc")
                        ? index_name + "_distance_asc"
                        : props.location.pathname.includes("price-asc")
                          ? index_name + "_price_asc"
                          : props.promotion.includes("buy to let opportunity") ? index_name + "_yield_desc" : index_name
              }
            />

            <CustomNoStats
              val={
                props.location.pathname.includes("most-recent")
                  ? index_name + "_most_recent"
                  : props.location.pathname.includes("distance-asc")
                    ? index_name + "_distance_asc"
                    : props.location.pathname.includes("price-asc")
                      ? index_name + "_price_asc"
                      : index_name
              }
              type={props.search_type}
            />
          </div>
          {props.mapView && (
            <>
              {(1 == 1) && (
                <div className="map-configure">
                  <Configure page={0} {...props.algoliaConfig} hitsPerPage={200} />
                </div>
              )}
            </>
          )}
          <div
            className={`${props.mapView ? "map-box grid-view" : "map-box map-box-listview"} ${1 == 1 ? "mobile-loc-map" : ""
              }`}
            id="res-div-two"
          >
            <div id="map-holder" className={classNames("map")}>
              {props.mapView && (1 == 1) ? (
                <CustomGeoSearch buttonrest={buttonrest} mapdraggedbyuser={mapdraggedbyuser} enablecluster="true" />
              ) : (
                <CustomGeoSearch buttonrest={buttonrest} mapdraggedbyuser={mapdraggedbyuser} enablecluster="false" />
              )}
            </div>
          </div>
        </div>
      </InstantSearch>
      }
      {/* get all search hits*/}
      {realUser && render &&
        <InstantSearch
        indexName={index_name}
        searchClient={client}
        onSearchStateChange={state => {
          props.changeStateAndUrl(state)
        }}
        hits
        attributesToRetrieve = {[
          "crm_id",
          "slug"
        ]}
        stalledSearchDelay={1000}
      > 
         <Configure filters={`publish:true AND search_type:${props.searchType} AND show_on_search:true`} aroundLatLng={props.aroundLatLng} aroundRadius={props.aroundRadius} getRankingInfo={props.getRankingInfo} {...props.algoliaConfig} hitsPerPage={200}    
         attributesToRetrieve = {[
          "crm_id",
          "slug"
        ]} />
        <div className="d-none">
        <FilterBlock
          {...props}
         
          buttonrest={buttonrest}
          includeSold={includeSold}
          mapdraggedbyuser={mapdraggedbyuser}
          includeUnderOffer={includeUnderOffer}
          mapView={props.mapView}
          searchType={props.searchType}
          query={props.query}
          index_name={index_name}
          search_area={props.search_area}
          h1={props.h1}
          desc={props.desc}
          off_plan={false}
          sales={props.searchType === "sales" ? true : false}
          changeRadius={props.changeRadius}
        />
        </div> 
         <CustomAllHits  {...props} />
      </InstantSearch>
      }


      {scrollToTopBtn && (
        <button onClick={scrollToTop} className="back-to-top">
          <i className="icon-up"></i>
        </button>
      )}
      {/* <div id="res-div-loading" className="res-div-loading">Loading</div> */}
      <Footer
        searchtype={props.searchType}
        search="searchresults"
        searchPtype={props.property_type}
        popularSearch="propertyresults"
        searchBedroomfield={props.bedrooms}
        Searcharea={props.search_area}
      />
    </div>
  )
}

export default SearchTemplate
